import React from 'react';
import styles from 'common/_CircleLoaderSmall/CircleLoaderSmall.module.css';

export const CircleLoaderSmall = () => (
    <div className={styles.loader}>
        <span/>
    </div>
);
